import AppConfig from '@/modules/core/client/app/config';
import '@/modules/core/client/core.client.module';

AppConfig.registerModule('success', ['core']);

// config
require('@/modules/payment/client/config/success.client.routes');

angular.module('success').config(successRoutes);

/* @ngInject */
function successRoutes($stateProvider) {
  $stateProvider.state('success', {
    url: '/success',
    template: `<Success></Success>`,
    requiresAuth: true,
    data: {
      pageTitle: 'success',
    },
  });
  $stateProvider.state('cancel', {
    url: '/cancel',
    template: '<Cancel></Cancel>',
    requiresAuth: true,
    footerHidden: false,
    data: {
      pageTitle: 'cancel',
    },
  });
  $stateProvider.state('onboarding-complete', {
    url: '/onboarding-complete',
    template: '<onboarding-complete></onboarding-complete>',
    requiresAuth: true,
    data: {
      pageTitle: 'Stripe Onboarding Complete',
    },
  });
  $stateProvider.state('reauth', {
    url: '/reauth',
    template: '<reauth></reauth>',
    requiresAuth: true,
    data: {
      pageTitle: 'Stripe Reauthorization',
    },
  });
}
